import { giphyLocalUrl } from '@/app/util/env'
import { GET } from '@/app/util/url'
import { CSRF_COOKIE_NAME } from '@/util/user'
import { getCookie } from '@/util/url'
import { timeoutFetch } from 'utils/src/api/fetch'

export const getLoginCSRFToken = async () => {
    const currentToken = getCookie(CSRF_COOKIE_NAME)

    if (currentToken) {
        return currentToken
    }

    await timeoutFetch({
        url: `${giphyLocalUrl}/login/check/`,
        options: GET(),
        timeout: 10000,
    })

    return getCookie(CSRF_COOKIE_NAME)
}
